import { z } from 'zod'

export const ClubSchema = z.object({
	id: z.string(),
	storeId: z.string(),
	config: z.any(),
	active: z.boolean().nullable(),
	productId: z.string().nullable().optional(),
	createdAt: z.date(),
	updatedAt: z.date(),
})

export type ClubType = z.infer<typeof ClubSchema>

export const toClubDto = (data: any): ClubType => {
	return ClubSchema.parse(data)
}

export const toClubListDto = (data: any[]): ClubType[] => {
	return data.map(toClubDto)
}

